import { Box, createStyles, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { CloudUploadOutlined } from '@material-ui/icons';
import React from 'react';
import Dropzone, { DropEvent, FileRejection, DropzoneProps } from 'react-dropzone';

type Props = DropzoneProps & {
    title?: string;
    subtitle?: string;
}

function FileDrop(props: Props) {

    const classes = useStyles();

    const {
        title = 'Upload',
        subtitle = 'Arraste um arquivo aqui ou clique para abrir.',
    } = props;

    const [name, setName] = React.useState<string>(subtitle);

    function handleOnDrop<T extends File>(acceptedFiles: T[], fileRejections: FileRejection[], event: DropEvent) {
        setName(acceptedFiles[0].name);
        if (props.onDrop) props.onDrop(acceptedFiles, fileRejections, event);
    }

    return (
        <Dropzone {...props} onDrop={handleOnDrop}>
            {({ getRootProps, getInputProps }) => (
                <section>
                    <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        <Box className={classes.dropzone}>
                            <Box p={2}>
                                <Grid container alignItems="center">
                                    <Grid item xs={9}>
                                        <Grid container>
                                            <Typography variant="h6">{title}</Typography>
                                        </Grid>
                                        <Grid container>
                                            <Typography variant="subtitle1">{name}</Typography>
                                        </Grid>
                                    </Grid>
                                    <Grid item xs={3}>
                                        <Grid container justifyContent="flex-end">
                                            <CloudUploadOutlined style={{ fontSize: 48 }} />
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                    </div>
                </section>
            )}
        </Dropzone>
    );
}

const useStyles = makeStyles((theme: Theme) => createStyles({
    dropzone: {
        border: '1px dashed',
        borderColor: theme.palette.action.disabled,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.action.focus,
    }
}));

export default FileDrop;